<template>
	<div>
		<div class="row text-right mb-2">
			<div class="col">
				<Pagination
					:maxPage_prop =  "listBullionWithdrawals.length"
					@changePage = "listBullionWithdrawalsPageIndex = $event"
				>
				</Pagination>
			</div>
		</div>
		<div class="row">
			<div class="col-12">
				
				<table class="table table-striped">
					<thead class="text-center" style="background-color: #0f0f17">
						<tr>
							<th style="border-right: 2px solid #1e1e2e;">NO.</th>
							<th style="border-right: 2px solid #1e1e2e;">RECEIPT NUMBER</th>
							<th style="border-right: 2px solid #1e1e2e;">DATE OF SHIPMENT</th>
							<th style="border-right: 2px solid #1e1e2e;">QUANTITY (BAR/S)</th>
							<th style="border-right: 2px solid #1e1e2e;">WEIGHT (GRAM)</th>
							<th style="border-right: 2px solid #1e1e2e;">VALUE GOODS</th>
							<th style="border-right: 2px solid #1e1e2e;">ACTION</th>
						</tr>
					</thead>
					<tbody>
						<tr v-if="apiStatusGetPackages == 'loading'">
							<td class="text-center" colspan="5" rowspan="3">
								<Loader
									size_prop="10em"
								></Loader>
							</td>
						</tr>
						<tr v-else-if="packages.length < 0">
					    <td colspan="5" class="text-center">No data available in table</td>
						</tr>
						<tr v-else v-for="(listBullionWithdrawal, index) in listBullionWithdrawals[listBullionWithdrawalsPageIndex]" :key="listBullionWithdrawal.order_id">
							<td class="text-center">{{(index + 1) + ((Math.pow(10, listBullionWithdrawalsPageIndex) == 1 ? 0 : Math.pow(10, listBullionWithdrawalsPageIndex)))}}</td>
							<td class="text-center">{{listBullionWithdrawal.ref_number}}</td>
							<td class="text-center">{{(new Date(listBullionWithdrawal.withdrawal_date).getDate() &lt; 10) ? `0${new Date(listBullionWithdrawal.withdrawal_date).getDate()}` : new Date(listBullionWithdrawal.withdrawal_date).getDate()}}/{{(new Date(listBullionWithdrawal.withdrawal_date).getMonth() + 1 &lt; 10) ? `0${new Date(listBullionWithdrawal.withdrawal_date).getMonth() + 1}` : new Date(listBullionWithdrawal.withdrawal_date).getMonth() + 1}}/{{new Date(listBullionWithdrawal.withdrawal_date).getFullYear()}} {{ (new Date(listBullionWithdrawal.withdrawal_date).getHours() &lt; 10) ? `0${new Date(listBullionWithdrawal.withdrawal_date).getHours()}` : new Date(listBullionWithdrawal.withdrawal_date).getHours() }}:{{ (new Date(listBullionWithdrawal.withdrawal_date).getMinutes() &lt; 10) ? `0${new Date(listBullionWithdrawal.withdrawal_date).getMinutes()}` : new Date(listBullionWithdrawal.withdrawal_date).getMinutes() }}</td>
							<td class="text-right">{{listBullionWithdrawal.quantity}}</td>
							<td class="text-right">{{listBullionWithdrawal.weight}}</td>
							<td class="text-right">Rp. {{numberFormat(listBullionWithdrawal.valuegoods)}}</td>
							<td class="text-center"><button class="btn btn-sm" @click="openTrackBullionHistory(listBullionWithdrawalsPageIndex, index)">DETAIL</button></td>
						</tr>
					</tbody>
					<tfoot>
					</tfoot>
				</table>

			</div>
		</div>

		<TrackBullionHistory
			v-show = "trackBullionHistoryIsOpen"
			@close = "trackBullionHistoryIsOpen = false"
			:data_prop = "bullionWithdrawalDetail"
		>
		</TrackBullionHistory>
	</div>
</template>

<script>
	import axios from 'axios'

	import Loader from '@/components/Loader.vue'
	import TrackBullionHistory from '@/components/TrackBullionHistory.vue'
	import Pagination from '@/components/Pagination.vue'

	export default {
		name: 'TrackBullion',
		components: {
			Loader,
			TrackBullionHistory,
			Pagination
		},
		data() {
			return {
				packages: [],
				apiStatusGetPackages: 'idle',
				trackBullionHistoryIsOpen: false,
				listBullionWithdrawals: [],
				bullionWithdrawalDetail: {},
				listBullionWithdrawalsPageIndex: 0,
			}
		},

		computed: {
		},

		created() {
			axios({
				method: 'GET',
				url: process.env.VUE_APP_BACKEND_URL+'/poslog/get/list_bullion_withdrawal',
			})
			.then(response => {
				let sortedlistBullionWithdrawals = response.data.data.slice().sort((a, b) => new Date(b.withdrawal_date) - new Date(a.withdrawal_date))
				this.listBullionWithdrawals = this.paginationOrder(sortedlistBullionWithdrawals)
				console.log('berhasil list bullion withdrawal', response)
			})
			.catch(error => {
				if (error.response) {
					/*
					 * The request was made and the server responded with a
					 * status code that falls out of the range of 2xx
					 */
					console.log(error.response.data);
					console.log(error.response.status);
					console.log(error.response.headers);
				} else if (error.request) {
					/*
					 * The request was made but no response was received, `error.request`
					 * is an instance of XMLHttpRequest in the browser and an instance
					 * of http.ClientRequest in Node.js
					 */
					console.log(error.request);
				} else {
					// Something happened in setting up the request and triggered an Error
					console.log(error.message);
				}
				console.log('gagal list bullion withdrawal', error.config);
			})
		},
		methods: {
			numberFormat(value) {
				let val = (value / 1)
				return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') //comma separator
			},

			openTrackBullionHistory(index1, index2) {
				this.bullionWithdrawalDetail = this.listBullionWithdrawals[index1][index2]

				this.trackBullionHistoryIsOpen = true
			},

			paginationOrder(arr) {
				const itemPerPage = 10
				let arrTemp1 = [],
						arrTemp2 = []
				for (let i = 0; i < arr.length; i++) {
					arrTemp1.push(arr[i])
					if ((i+1) % itemPerPage == 0 || (i == arr.length - 1 && (i+1) % itemPerPage != 0)) {
						arrTemp2.push(arrTemp1)
						arrTemp1 = []
					}
				}
				return arrTemp2
			},
		}
	}
</script>